var exports = {
  "k": "x61f99309--e9c257--container",
};

module.exports = exports;
